import { useEffect, useState } from "react";

import { api } from "../../lib/api";
import { Airport, AirportService } from "../../types/airport";
import { List } from "../../types/resquest";
import { getToken } from "../../storage/auth";
import {DataTableUtils} from "../../components/DataTable/DataTableUtils";

interface IList {
  keyword?: string;
  page?: number;
  limit?: number;
  sort?: string;
  status?: boolean;
}

const entity = "airports";
const dataTableUtils = new DataTableUtils(entity);

export const useList = (
  params?: IList,
  token?: string,
  isCombo?: boolean
):
  | Promise<{ data: AirportService[]; meta: List; isLoading: boolean }>
  | any => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState<AirportService[]>([{} as AirportService]);
  const [meta, setMeta] = useState<List>({} as List);
  const [combo, setCombo] = useState<any>();

  const render = () => {
    if (token) {
      if (isCombo === false || isCombo === undefined) {
        return "paginate";
      }
    }
  };

  useEffect(() => {
    if (render() === "paginate") {
      (async function () {
        setIsLoading(true);
        const response = await dataTableUtils.findPaginate(params);
        const {total, data, currentPage, totalPages, limit} = response.data;
        setData(data);
        setMeta((prevState) => ({
          ...prevState,
          total,
          totalPages,
          limit,
          currentPage,
        }));
        setIsLoading(false)
      })();
    }
  }, [isCombo, params, token]);

  useEffect(() => {
    if (token && isCombo === true) {
      setIsLoading(true);
      api
        .get(`/${entity}/getCombo`, {
          params,
          headers: { authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const { data } = response;
          setCombo(data);
        })
        .finally(() => setIsLoading(false));
    }
  }, [isCombo, params, token]);

  return { data, meta, isLoading, combo };
};

export const update = async (
  id: number | string,
  airport?: any
): Promise<Airport> => {
  const token = getToken();
  const { data } = await api.patch(`/${entity}/${id}`, airport, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};
export const deleteAirport = async (id: number | string): Promise<Airport> => {
  const token = getToken();
  const { data } = await api.delete(`/${entity}/${id}`, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const isInUse = async (id: number | string): Promise<any> => {
  const token = getToken();
  const { data } = await api.get(`/${entity}/isInUse/${id}`, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const create = async (airport?: any): Promise<Airport> => {
  const token = getToken();
  const { data } = await api.post(`/${entity}`, airport, {
    headers: { authorization: `Bearer ${token}` },
  });

  return data;
};

export const exportAll = async (params) => {
  let xlsxData = [
    { label: "Id", value: "ID_AEROPORTO" },
    { label: "Abbreviation", value: "SIGLA_AEROPORTO" },
    { label: "Description", value: "DSC_AEROPORTO" },
    {
      label: "Status",
      value: (row: any) => (row.ATIVO ? "Active" : "Inactive"),
    },
  ]
  await dataTableUtils.exportAll({params, xlsxData, filename: "Airport"});
};
